import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useBridgeClubAuth } from '../../contexts/BridgeClubAuthContext';
import { deliveryAPI } from '../../services/deliveryAPI';

const RED = '#B91C1C';

/**
 * /bridge-club/card-link/:token - the link staff email after a property walk.
 *
 * Opening the page does nothing by itself: the link is single-use, and mail
 * scanners open links. The customer taps Continue, which redeems the link (it
 * verifies their email and signs them in, no password needed), and the setup
 * flow then resumes at the card - everything else was captured on the walk.
 */
const CardLinkPage: React.FC = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { refreshMember } = useBridgeClubAuth();
  const [working, setWorking] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const go = async () => {
    if (!token) return;
    setWorking(true);
    setError(null);
    try {
      const result = await deliveryAPI.redeemCardLink(token);
      await refreshMember();
      navigate(result.next || '/bridge-club/onboarding', { replace: true });
    } catch (err: any) {
      setError(err?.error || "We couldn't open this link. Call us at (509) 738-9004.");
      setWorking(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f7f7f7' }}>
      <header style={{ background: RED, color: '#fff', padding: 16, textAlign: 'center' }}>
        <img src="/rbf-logo.png" alt="Red Bridge Farm" style={{ height: 34 }} />
      </header>
      <main style={{ maxWidth: 480, margin: '0 auto', padding: '28px 16px' }}>
        <h1 style={{ color: RED, fontSize: 26, margin: '0 0 8px' }}>Add the card for your deliveries</h1>
        <p style={{ color: '#374151', fontSize: 17, lineHeight: 1.5 }}>
          We've set up everything else with you. The card is the one part only you do. Nobody at
          Red Bridge sees your card number.
        </p>
        <p style={{ color: '#374151', fontSize: 17, lineHeight: 1.5 }}>
          Nothing is charged today. You won't need a password; you can set one later in your profile.
        </p>
        {error && (
          <div style={{ background: '#FEF2F2', color: '#991B1B', border: '1px solid #FCA5A5',
            borderRadius: 8, padding: '12px 14px', margin: '16px 0', fontSize: 15 }}>
            {error}
          </div>
        )}
        <button
          type="button"
          onClick={go}
          disabled={working}
          style={{ width: '100%', minHeight: 56, border: 'none', borderRadius: 10,
            background: working ? '#9CA3AF' : RED, color: '#fff', fontSize: 19, fontWeight: 800,
            cursor: working ? 'default' : 'pointer', marginTop: 12 }}
        >
          {working ? 'Opening…' : 'Continue'}
        </button>
        {error && (
          <p style={{ textAlign: 'center', marginTop: 16 }}>
            <Link to="/bridge-club/login" style={{ color: RED, fontWeight: 700 }}>Sign in instead</Link>
          </p>
        )}
      </main>
    </div>
  );
};

export default CardLinkPage;
